import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const BranchList = styled.table`
  border-collapse: collapse;
  border-spacing: 0px;
  border-radius: 5px;
  /* border: 1px solid ${colors.secondary.lightGray3}; */
  border-style: hidden; /* hide standard table (collapsed) border */
  box-shadow: 0 0 0 1px ${colors.secondary.lightGray3}; /* this draws the table border  */
  /* display: flex;
  flex-direction: column;
  gap: 20px; */

  th,
  td {
    padding: 10px;
  }

  tr {
    border: 1px solid ${colors.secondary.lightGray3};
  }
  td {
    /* border: 1px solid ${colors.secondary.lightGray3}; */
  }
`;

export const BranchListHeader = styled.thead`
  background: ${colors.secondary.lightGray1};
  th {
    border-radius: 5px;
  }
  th {
    text-align: left;
    padding: 10px;
  }
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
`;

export const BranchListBody = styled.tbody``;

export const Branch = styled.tr`
  /* padding: 15px 25px;
  border: 1px solid ${colors.secondary.lightGray3};
  background: ${colors.secondary.lightGray1};
  border-radius: 5px; */
`;

export const File = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;

  .filename {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  span.filesize {
    text-transform: lowercase;
  }
`;

export const CommitDiff = styled.div`
  @media (max-width: ${breakPoints.mobile}) {
    display: none;
  }
`;
